/**
 * Boreless Nation · Tarjeta de confirmación de añadido.
 *
 * - No abre el drawer automáticamente.
 * - Solo responde a altas confirmadas desde product-form-component.
 * - Muestra feedback inmediato y después completa los datos con la variante exacta.
 * - Nunca usa el último artículo del carrito como sustituto de una variante no resuelta.
 */
(function () {
  'use strict';

  var HIDE_MS = 5000;
  var el, heading, img, nameEl, metaEl, cta, closeBtn, timer = null, booted = false;

  function clearTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function scheduleHide() {
    clearTimer();
    timer = setTimeout(hide, HIDE_MS);
  }

  function hide() {
    clearTimer();
    if (el) {
      el.setAttribute('hidden', '');
      el.classList.remove('is-visible');
    }
  }

  function show() {
    el.removeAttribute('hidden');
    void el.offsetWidth;
    el.classList.add('is-visible');
    scheduleHide();
  }

  function normalizeImg(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function render(data) {
    heading.textContent = data.pack ? 'AÑADIDO A TU PACK' : 'AÑADIDO AL CARRITO';

    var src = normalizeImg(data.image);
    if (src) {
      img.src = src;
      img.style.display = '';
    } else {
      img.removeAttribute('src');
      img.style.display = 'none';
    }

    nameEl.textContent = data.name || '';
    metaEl.textContent = data.meta || '';
    show();
  }

  function cartRoute(file) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return (root + file).replace(/\/{2,}/g, '/');
  }

  function numericId(value) {
    var text = String(value == null ? '' : value).trim();
    if (/^\d+$/.test(text)) return text;

    var gidMatch = text.match(/ProductVariant\/(\d+)$/i);
    return gidMatch ? gidMatch[1] : '';
  }

  function variantIdFromEvent(detail, data) {
    var candidates = [
      detail && detail.sourceId,
      data && data.variantId,
      data && data.variant_id,
      detail && detail.resource && detail.resource.variant_id,
      detail && detail.resource && detail.resource.id
    ];

    var i;
    for (i = 0; i < candidates.length; i += 1) {
      var direct = numericId(candidates[i]);
      if (direct) return direct;
    }

    var sourceId = detail && detail.sourceId ? String(detail.sourceId) : '';
    if (!sourceId) return '';

    var sourceEl = document.getElementById(sourceId);
    if (!sourceEl) return '';

    var variantInput = sourceEl.querySelector('input[name="id"]');
    return variantInput ? numericId(variantInput.value) : '';
  }

  function lineVariantId(line) {
    if (!line) return '';
    return numericId(line.variant_id != null ? line.variant_id : line.id);
  }

  function findExactLine(cart, variantId) {
    if (!cart || !Array.isArray(cart.items) || !variantId) return null;

    var i;
    for (i = cart.items.length - 1; i >= 0; i -= 1) {
      if (lineVariantId(cart.items[i]) === String(variantId)) return cart.items[i];
    }
    return null;
  }

  function productLines(cart, productId) {
    if (!cart || !Array.isArray(cart.items) || !productId) return [];

    return cart.items.filter(function (line) {
      return String(line.product_id) === String(productId);
    });
  }

  function readCart() {
    return fetch(cartRoute('cart.js'), {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('cart read failed');
      return response.json();
    });
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function resolveAddedLine(variantId, productId, attempt) {
    return readCart().then(function (cart) {
      var exact = findExactLine(cart, variantId);
      if (exact) return { cart: cart, line: exact, exact: true };

      if (variantId && attempt < 2) {
        return wait(attempt === 0 ? 120 : 260).then(function () {
          return resolveAddedLine(variantId, productId, attempt + 1);
        });
      }

      var matches = productLines(cart, productId);
      if (matches.length === 1) return { cart: cart, line: matches[0], exact: false };

      return { cart: cart, line: null, exact: false, productMatches: matches };
    });
  }

  function renderProductLine(line, addedQty) {
    var meta = '';
    if (line.variant_title && line.variant_title !== 'Default Title') {
      meta = line.variant_title;
    }
    if (addedQty > 1) {
      meta += (meta ? '  ·  ' : '') + 'x' + addedQty;
    }

    render({
      pack: false,
      image: line.image || (line.featured_image && line.featured_image.url) || null,
      name: line.product_title || line.title || 'Producto añadido',
      meta: meta
    });
  }

  function onCartUpdate(event) {
    var detail = (event && event.detail) || {};
    var data = detail.data || {};

    if (data.didError) return;
    if (data.source !== 'product-form-component') return;

    var isBuilder = detail.sourceId === 'bn-bundle-builder';
    var addedQty = Number(data.itemCount) || 0;

    if (isBuilder) {
      render({
        pack: true,
        image: null,
        name: addedQty > 0
          ? addedQty + ' ' + (addedQty === 1 ? 'unidad' : 'unidades') + ' a tu pack'
          : 'Selección añadida',
        meta: ''
      });

      readCart().then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;
        var last = cart.items[cart.items.length - 1];
        render({
          pack: true,
          image: last ? last.image : null,
          name: addedQty > 0
            ? addedQty + ' ' + (addedQty === 1 ? 'unidad' : 'unidades') + ' a tu pack'
            : 'Selección añadida',
          meta: ''
        });
      }).catch(function () {
        // El evento ya confirmó el alta. Se conserva el feedback genérico.
      });
      return;
    }

    // Feedback inmediato: el evento solo se emite después de un alta correcta.
    // Los datos exactos se completan a continuación sin bloquear la tarjeta.
    render({
      pack: false,
      image: null,
      name: 'Producto añadido',
      meta: addedQty > 1 ? 'x' + addedQty : ''
    });

    var variantId = variantIdFromEvent(detail, data);
    resolveAddedLine(variantId, data.productId, 0)
      .then(function (result) {
        if (result.line) {
          renderProductLine(result.line, addedQty);
          return;
        }

        var matches = result.productMatches || [];
        if (matches.length > 0) {
          render({
            pack: false,
            image: null,
            name: matches[0].product_title || 'Producto añadido',
            meta: addedQty > 1 ? 'x' + addedQty : ''
          });
        }
      })
      .catch(function () {
        // El alta ya está confirmada; se mantiene la tarjeta genérica.
      });
  }

  function boot() {
    if (booted) return;

    el = document.getElementById('bn-add-confirm');
    if (!el) return;

    heading = el.querySelector('[data-bn-ac-heading]');
    img = el.querySelector('[data-bn-ac-img]');
    nameEl = el.querySelector('[data-bn-ac-name]');
    metaEl = el.querySelector('[data-bn-ac-meta]');
    cta = el.querySelector('[data-bn-ac-cta]');
    closeBtn = el.querySelector('[data-bn-ac-close]');

    if (!heading || !img || !nameEl || !metaEl || !cta || !closeBtn) return;
    booted = true;

    el.addEventListener('mouseenter', clearTimer);
    el.addEventListener('mouseleave', scheduleHide);
    el.addEventListener('focusin', clearTimer);
    el.addEventListener('focusout', scheduleHide);

    closeBtn.addEventListener('click', hide);

    cta.addEventListener('click', function (event) {
      var component = document.querySelector('cart-drawer-component');
      hide();

      if (component && typeof component.open === 'function') {
        event.preventDefault();
        try {
          component.open();
        } catch (error) {
          window.location.href = cta.getAttribute('href') || '/cart';
        }
      }
    });

    document.addEventListener('cart:update', onCartUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
